import type {
  AddressHistory,
  BankAccount,
  Borrower,
  BtlAddress,
  Individual,
  UkResidency,
} from '@api/btlApplicationForm/types';
import {
  MaritalStatus,
  ResidencyStatus,
  TaxpayerType,
} from '@pages/BtlApplicationFormPage/Applicants/Individual/types';

const mockAddress: BtlAddress = {
  id: 'lv28rqcbwm0j9ms6uvp6ro9f',
  addressLine1: 'test-address-line-1',
  addressLine2: null,
  postcode: 'AB1 2CD',
  town: 'test-town',
  country: 'test-country',
};

const mockAddress2: BtlAddress = {
  id: 'fum37ha0fg9w20m7ia441od9',
  addressLine1: 'test-address-line-1',
  addressLine2: null,
  postcode: 'AB1 2CD',
  town: 'test-town',
  country: 'test-country',
};

const mockResidency: UkResidency = {
  id: 'z57wbx9tl3b7rvfvm22iuorj',
  status: ResidencyStatus.BRITISH_CITIZEN,
  visaEndDate: new Date('2023-01-31T23:00:00.000Z'),
  dualNationality: null,
};

const mockResidency2: UkResidency = {
  id: 'vj8f8hb9dsyoey9dz26zx11y',
  status: ResidencyStatus.BRITISH_CITIZEN,
  visaEndDate: new Date('2023-01-31T23:00:00.000Z'),
  dualNationality: null,
};

const mockAddressHistory: AddressHistory = {
  id: 'jqd85kbl5xhy2fwyopv3e7ma',
  moveInDate: new Date('2022-09-05'),
  moveOutDate: null,
  isCurrentAddress: true,
  residentialStatus: null,
  residentialStatusDescription: null,
  address: mockAddress,
};

const mockAddressHistory2: AddressHistory = {
  id: 'c3mv72loxpwih0pxvo0z8lsa',
  moveInDate: new Date('2022-09-05'),
  moveOutDate: null,
  isCurrentAddress: true,
  residentialStatus: null,
  residentialStatusDescription: null,
  address: mockAddress2,
};

const mockIndividual1: Individual = {
  id: 'ind_01h2x3y4z5abc',
  title: 'test-title',
  firstName: 'test-first-name',
  middleName: 'test-middle-name',
  lastName: 'test-last-name',
  dateOfBirth: new Date('1975-03-08'),
  maritalStatus: MaritalStatus.MARRIED,
  nationality: 'British',
  retiringWithin10Years: null,
  projectedRetirementPayeIncome: 100000,
  previousTitle: null,
  previousFirstName: null,
  previousMiddleName: null,
  previousLastName: null,
  countryOfResidence: 'United Kingdom',
  isExpatriate: false,
  ukResidentTwelveMonths: null,
  isPortfolioLandlord: false,
  isFirstTimeBuyer: false,
  isFirstTimeLandlord: false,
  yearsLandlordExperience: 5,
  relationshipToSpv: null,
  bankruptcy: false,
  ccj: false,
  creditDefaults: false,
  paydayLoans: false,
  propertyRepossession: false,
  criminalConvictions: false,
  missedFinancePayments: false,
  isPoliticallyExposedPerson: false,
  taxpayerType: TaxpayerType.UK_BASIC_RATE,
  isPrimary: false,
  residencyStatus: mockResidency,
  incomes: [],
  contactDetails: [],
  addressHistory: [mockAddressHistory],
  expectedGrossIncome: null,
  isVulnerable: false,
  vulnerabilityCategory: null,
  vulnerabilityDetails: null,
  vulnerabilityDateIdentified: null,
};

const mockIndividual2: Individual = {
  ...mockIndividual1,
  id: 'ind_01h2x3y4z5def',
  residencyStatus: mockResidency2,
  addressHistory: [mockAddressHistory2],
};

const mockBankAccount: BankAccount = {
  id: 'mock-bank-account-id',
  sortCode: '00-00-00',
  accountNumber: '00000000',
  accountName: 'Test Account',
  bank: {
    id: 'mock-bank-id',
    name: 'Test Bank',
    address: {
      addressLine1: 'test-address-line-1',
      postcode: 'AB1 2CD',
      town: 'test-town',
      country: 'test-country',
    },
  },
};

export const MOCK_BORROWER: Borrower = {
  id: 'i3h0imcefj1nbxj68eg9r267',
  bankAccount: mockBankAccount,
  individuals: [mockIndividual1, mockIndividual2],
  individualOrder: [],
  companies: [],
  salutation: 'test-first-name test-middle-name test-last-name, test-first-name test-middle-name test-last-name',
  customSalutation: null,
  borrowerType: 'INDIVIDUAL',
};
